import { z } from "zod"
import { FrequencyEnum } from "../shared/common"

export const GoalTypeEnum = {
  Open: "Open",
  NPS: "NPS",
  Predefined: "Predefined",
  Classification: "Classification",
  Informative: "Informative",
} as const

export type GoalType = keyof typeof GoalTypeEnum

export const GoalMediaStrategyEnum = {
  ShareAll: "ShareAll",
  RandomPick: "RandomPick",
} as const

export type GoalMediaStrategy = keyof typeof GoalMediaStrategyEnum

export const GoalMediaTypeEnum = z.enum(["IMAGE", "VIDEO", "GIF", "AUDIO", "DOCUMENT"])

export const GoalsMediaResponseData = z.object({
  order: z.number(),
  link: z.string(),
  mediaType: GoalMediaTypeEnum,
  label: z.string().nullish(),
})

export const GoalResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  name: z.string(),
  displayName: z.string(),
  assistantInstructions: z.string().nullable(),
  insightsInstructions: z.string().nullable(),
  slug: z.string(),
  type: z.enum(GoalTypeEnum),
  frequency: z.enum(FrequencyEnum),
  shots: z.number().nullable(),
  isUnderlying: z.boolean().optional(),
  isSystemGoal: z.boolean().optional(),
  goalOptions: z.array(
    z.object({
      id: z.bigint().transform(String),
      value: z.string(),
    }),
  ),
  secondTurnBias: z.string().nullable(),
  activeCampaigns: z.number().optional(),
  hasChangeLog: z.boolean().optional(),
  createdAt: z.date().transform((value) => value.toISOString()),
  goalMedias: z.array(GoalsMediaResponseData).nullish(),
  mediaStrategy: z.enum(GoalMediaStrategyEnum).optional(),
})

export const GoalsResponseDataSchema = z.array(GoalResponseDataSchema)

export const UploadGoalsMediaResponseData = z.object({
  url: z.string(),
  type: GoalMediaTypeEnum,
})
